import FeatherIcon from "feather-icons-react";
import moment from "moment";
import { useState } from "react";
import { Popup } from "semantic-ui-react";
import { banksFormat } from "src/utils/bankList";
import { formatMoneyWithCurrency } from "src/utils/formatter";
import ModalTransactionDetail from "src/components/general/js/forms/reconcile/components/ModalTransactionDetail";
import { dt } from "src/utils/documentsI18n";

const TransactionContent = ({ data, docId }) => {

  const [showDetailModal, setShowDetailModal] = useState(false);

  const txType = (data?.type || '').toUpperCase();
  const isDebit = txType === 'SPEND' || !!data?.meta?.isReceived;
  const typeLabel = txType === 'RECIEVED' || txType === 'RECEIVED'
    ? dt('detail.matchTransaction.credit')
    : dt('detail.matchTransaction.debit');

  const findMatchInfo = () => {

    if (!data?.matchs) return null;

    const matchFound = data.matchs.find(match => match.docId === docId);
    return matchFound || null;
  };

  const matchInfo = findMatchInfo();
  const userRelated = matchInfo?.userRelated;
  const matchUser = userRelated
    ? dt('detail.matchTransaction.matchedBy', {
      email: userRelated?.email || '-',
      date: moment(userRelated?.date).format('DD/MM/YYYY HH:mm'),
    })
    : '-';

  const amountClass = isDebit ? 'tw-text-red-500' : 'tw-text-green-500';

  const bankName = banksFormat[data?.bankId] || data?.bankId || '';
  const movementDate = data?.date ? moment(data.date).format("DD/MM/YYYY") : '-';

  return (
    <>
      <div className="tw-flex tw-py-2 tw-items-center tw-px-2">
        <div className="tw-w-[15%]">
          <p className={`${amountClass} tw-text-sm tw-font-semibold !tw-p-0 !tw-m-0`}>{formatMoneyWithCurrency(Math.abs(matchInfo?.matchedAmount || matchInfo?.amount || 0))}</p>
        </div>
        <div className="tw-w-[15%]">
          <p className="tw-text-sm tw-font-semibold !tw-p-0 !tw-m-0 tw-text-gray-600">{movementDate}</p>
        </div>
        <div className="tw-w-[70%]">
          <div className="tw-flex tw-gap-2 tw-items-center">
            <p
              className="tw-text-blue-600 tw-text-sm tw-font-normal !tw-p-0 !tw-m-0 tw-cursor-pointer tw-underline hover:tw-text-blue-800"
              onClick={() => setShowDetailModal(true)}
            >
              {dt('detail.matchTransaction.viaBank', { type: typeLabel, bank: bankName })}
            </p>
            {
              matchUser && (
                <Popup
                  trigger={
                    <FeatherIcon
                      icon="info"
                      size={18}
                      className="tw-text-white"
                      fill="#2563eb"
                      stroke="white"
                    />
                  }
                  content={matchUser}
                  disabled={!matchUser}
                  position="top center"
                  hoverable
                  inverted
                />
              )
            }
          </div>
          <div className="tw-flex">
            <Popup
              trigger={
                <p className="tw-text-gray-600 tw-text-sm tw-font-bold !tw-p-0 !tw-m-0 tw-truncate">
                  {data?.description}
                </p>
              }
              content={data?.description}
              disabled={!data?.description || data?.description.length <= 40}
              position="top center"
              hoverable
              inverted
            />
          </div>


        </div>
      </div >

      <ModalTransactionDetail
        isVisible={showDetailModal}
        onClose={() => setShowDetailModal(false)}
        transaction={data}
      />
    </>
  );
};

export default TransactionContent;